var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobInProgressIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.25C7.5 1.97386 7.27615 1.75 7 1.75C6.72385 1.75 6.5 1.97386 6.5 2.25V4.5C6.5 4.6519 6.56905 4.79555 6.68765 4.89045L7.93765 5.89045C8.1533 6.06295 8.46795 6.028 8.64045 5.81235C8.81295 5.5967 8.778 5.28205 8.56235 5.10955L7.5 4.2597V2.25Z",
    fill: "#4A8DF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 4.5C2.5 2.01472 4.5147 0 7 0C9.4853 0 11.5 2.01472 11.5 4.5C11.5 6.9853 9.4853 9 7 9C4.5147 9 2.5 6.9853 2.5 4.5ZM7 1C5.067 1 3.5 2.56701 3.5 4.5C3.5 6.433 5.067 8 7 8C8.933 8 10.5 6.433 10.5 4.5C10.5 2.56701 8.933 1 7 1Z",
    fill: "#4A8DF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.5C1.72386 11.5 1.5 11.7239 1.5 12C1.5 12.2761 1.72386 12.5 2 12.5H5C5.27615 12.5 5.5 12.2761 5.5 12C5.5 11.7239 5.27615 11.5 5 11.5H2Z",
    fill: "#4A8DF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10C0.89543 10 0 10.8954 0 12C0 13.1045 0.89543 14 2 14H12C13.1046 14 14 13.1045 14 12C14 10.8954 13.1046 10 12 10H2ZM1 12C1 11.4477 1.44772 11 2 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H2C1.44772 13 1 12.5523 1 12Z",
    fill: "#4A8DF2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobInProgressIcon);
export default __webpack_public_path__ + "static/media/JobInProgressIcon.31625ea0cff337f32f572a02293634ed.svg";
export { ForwardRef as ReactComponent };